var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-container"},[_c('input',_vm._b({staticClass:"app-input",style:(("border-color: " + _vm.borderColor)),domProps:{"value":_vm.value},on:{"input":_vm.sendValue,"blur":_vm.blurValue}},'input',_vm.$attrs,false)),_vm._v(" "),_c('span',{staticClass:"err-message"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06758668","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/inputs/app-input.vue
// module id = 817
// module chunks = 2 3 4 5 6 7 8 9 10 11 12 13 14 17 18